import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PrivateComponent } from './private.component';
import { PrivateHomeComponent } from './private-home/private-home.component';
import { SearchDocumentsComponent } from './documents/search-documents/search-documents.component';
import { CompaniesListsComponent } from './companies-lists/companies-lists.component';
import { EditCompanyComponent } from './companies/edit-company/edit-company.component';
import { CompanyDetailsComponent } from './companies/company-details/company-details.component';
import { AuthGuard } from '../guards/auth.guard';
import { AuthSystemAdminOnlyGuard } from '../guards/auth-system-admin-only.guard';
import { AuthSystemUserOrFinancierOnlyGuard } from '../guards/auth-system-admin-or-financier-only.guard';
import { FinancierCompaniesComponent } from './financier-companies/financier-companies.component';
import { FinancialMovementsComponent } from './documents/financial-movements/financial-movements.component';
import { DesignSystemComponent } from './design-system/design-system.component';
import { DesignSystemAllComponent } from './design-system/all/design-system.component-all';

const routes: Routes = [
	{
		path: 'private',
		component: PrivateComponent,
		children: [
			{
				path: '',
				pathMatch: 'full',
				redirectTo: 'home',
			},
			{
				path: 'design-system',
				component: DesignSystemComponent,
				canActivate: [AuthSystemAdminOnlyGuard],
			},
			{
				path: 'design-system/all',
				component: DesignSystemAllComponent,
				canActivate: [AuthSystemAdminOnlyGuard],
			},
			{
				path: 'home',
				component: PrivateHomeComponent,
				canActivate: [AuthGuard],
			},
			{
				path: 'documents',
				component: SearchDocumentsComponent,
				canActivate: [AuthGuard],
			},
			{
				path: 'documents/fileIntegration/:fileId',
				component: SearchDocumentsComponent,
				canActivate: [AuthGuard],
			},
			{
				path: 'documents/search/:searchCriteria',
				component: SearchDocumentsComponent,
				canActivate: [AuthGuard],
			},
			{
				path: 'documents/financial-movements/:documentId',
				component: FinancialMovementsComponent,
				canActivate: [AuthGuard],
			},
			{
				path: 'companies/financiers',
				component: FinancierCompaniesComponent,
				canActivate: [AuthGuard],
			},
			{
				path: 'companies',
				component: CompaniesListsComponent,
				canActivate: [AuthGuard],
			},
			{
				path: 'company/details/:companyId',
				component: CompanyDetailsComponent,
				canActivate: [AuthGuard],
			},
			{
				path: 'company/edit/:companyId',
				component: EditCompanyComponent,
				canActivate: [AuthGuard],
			},
			{
				path: 'users',
				loadChildren: () => import('./users/users.module').then((m) => m.UsersModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'contracts',
				loadChildren: () => import('./contracts/contracts.module').then((m) => m.ContractsModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'funding-request',
				loadChildren: () => import('./funding-request/funding-request.module').then((m) => m.FundingRequestModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'administration',
				loadChildren: () => import('./administration/administration.module').then((m) => m.AdministrationModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'files-upload',
				loadChildren: () => import('./files-upload/upload.module').then((m) => m.UploadModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'company',
				loadChildren: () => import('./companies/companies.module').then((m) => m.CompaniesModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'invitation',
				loadChildren: () => import('./invitations/invitations.module').then((m) => m.InvitationsModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'files-integration',
				loadChildren: () => import('./files-integration/files-integration.module').then((m) => m.FilesIntegrationModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'payment-request',
				loadChildren: () => import('./payment-request/payment-request.module').then((m) => m.PaymentRequestModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'help',
				loadChildren: () => import('./help/help.module').then((m) => m.HelpModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'help-center',
				loadChildren: () => import('./help-center/help-center.module').then((m) => m.HelpCenterModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'credit-assignment',
				loadChildren: () => import('./credit-assignment/credit-assignment.module').then((m) => m.CreditAssignmentModule),
				canActivate: [AuthGuard],
			},
			{
				path: 'advance-request',
				loadChildren: () => import('./advance-request/advance-request.module').then((m) => m.AdvanceRequestModule),
				canActivate: [AuthGuard],
			},
			// {
			// 	path: 'reporting',
			// 	loadChildren: () => import('./reporting/reporting.module').then((m) => m.ReportingModule),
			// 	canActivate: [AuthSystemAdminOnlyGuard],
			// },
			{
				path: 'monitoring',
				loadChildren: () => import('./monitoring/monitoring.module').then((m) => m.MonitoringModule),
				canActivate: [AuthSystemUserOrFinancierOnlyGuard],
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class PrivateRoutingModule {}
